var _regeneratorRuntime = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/createClass.js");

/*
  This adapter library is concerned with interfacing with the GitHub Gist API.
  It's used to download a more easily maintained list of Circuit Relays
  operated by members of the PSF.
*/
var axios = require('axios');

var Gist = /*#__PURE__*/function () {
  "use strict";

  function Gist() {
    var localConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Gist);

    this.axios = axios;
  } // Retrieve a JSON file from a GitHub Gist


  _createClass(Gist, [{
    key: "getCRList",
    value: function () {
      var _getCRList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var gistUrl, result, content, object;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                // https://gist.github.com/christroutner/e818ecdaed6c35075bfc0751bf222258
                gistUrl = 'https://api.github.com/gists/e818ecdaed6c35075bfc0751bf222258'; // Retrieve the gist from github.com.

                _context.next = 4;
                return this.axios.get(gistUrl);

              case 4:
                result = _context.sent;
                // console.log('result.data: ', result.data)
                // Get the current content of the gist.
                content = result.data.files['psf-circuit-relays.json'].content; // console.log('content: ', content)
                // Parse the JSON string into an Object.

                object = JSON.parse(content); // console.log('object: ', object)

                return _context.abrupt("return", object);

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                console.error('Error in getCRList()');
                throw _context.t0;

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 10]]);
      }));

      function getCRList() {
        return _getCRList.apply(this, arguments);
      }

      return getCRList;
    }()
  }]);

  return Gist;
}();

module.exports = Gist;